import type { Node } from 'slate';

import { Element } from 'slate';

import type { ReusableContentElement, ReusableContentMdNode } from '@ui/MarkdownEditor/types';

export const type = 'reusable-content' as ReusableContentElement['type'];
export const isReusableContent = (node: Node) => Element.isElementType(node, type);

export const fromMdNode = (node: ReusableContentMdNode, { renderingLibrary }) => {
  const source = node.source
    ? node.source
    : renderingLibrary['mdx' in renderingLibrary ? 'mdx' : 'md']({ children: node.children, type: 'root' });
  const newNode = {
    type,
    tag: node.tag,
    ...(source && { source }),
    children: [{ text: '' }] as [{ text: '' }],
  };

  return newNode;
};
